import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem, Typography } from "@mui/material";
import { MenuItemType, MenuPropsType } from "../../types/app.type";
import { MenuWrapper } from "./styled";
import { BaseLabel } from "../formfields/label/styled";
import { BaseInput } from "../formfields/input/styled";

export const Menu: React.FC<MenuPropsType<MenuItemType>> = ({ menuitems, permissions, open, location, activeModule, handleCheckboxChange }) => {
    const navigate = useNavigate();

    const handleNavigate = (path: string) => {
        return navigate(path);
    };

    const activeRights = useMemo(() => {
        if (location !== "access-control") return;
        return (
            permissions?.find((permission: Record<string, any>) => permission.module === activeModule)
                ?.rights?.map((right: Record<string, any>) => right.title) ?? []
        );
    }, [permissions, activeModule, location]);

    return (
        <MenuWrapper
            open={open}
        >
            {(location === "side-navigation") && (
                <ul>
                    {menuitems?.map((item: Record<any, any>, index: string) => {
                        return (
                            <MenuItem
                                key={index}
                                className={item.name.replace(/\s+/g, '').toLowerCase()}
                                onClick={() => handleNavigate(item.url.replace(/\s+/g, '').toLowerCase())}
                            >
                                {item.name}
                            </MenuItem>
                        )
                    })}
                </ul>
            )}
            {location === "access-control" && (
                <form>
                    {typeof activeModule === "string" && menuitems?.find((item: Record<any, any>) => item.module === activeModule)?.rights.map((right: Record<string, string>, index: string) => (
                        <BaseLabel
                            key={index}
                        >
                            <BaseInput
                                type="checkbox"
                                name={right.title}
                                inputProps={{
                                    checked: activeRights?.includes(right.title),
                                }}
                                onChange={() => handleCheckboxChange?.(activeModule as string, right.title)}
                            />
                            <Typography
                                component={"span"}
                                variant="subtitle1"
                                fontFamily={"Inter"}
                                fontWeight={500}
                                fontSize={13}
                                lineHeight={"normal"}
                                color={"#666666"}
                            >
                                {right.title}
                            </Typography>
                        </BaseLabel>
                    ))}
                </form>
            )}
        </MenuWrapper>
    )
}